import React from 'react';

import dayjs from 'dayjs';

import { PagintaionParams } from 'shared/CustomPagination/CustomPagination';

import { BookingWaitList } from 'features/bookingWait';
import { WorkTime } from 'features/config';
import { CourtInfo, CourtsList } from 'features/courts';
import { bookingType, Column, CourtsBooking, getBookingColor, SelectedBookingCourt } from 'features/courtsBooking';

import BookingDescription from './BookingDescription';
import ColumnTittle from './ColumnTittle';

interface Props {
  handleBooking: (arg: SelectedBookingCourt) => void;
  handleCheckDetail: (ids: number[]) => void;
  editWaiting: (bookingsWaitId: number[]) => void;
  items: CourtsBooking;
  params: PagintaionParams;
  courts: CourtsList;
  workTime: WorkTime;
  waitingList: BookingWaitList;
}

type CourtBooking = CourtsBooking[number];

function GraphColumns({
  handleBooking,
  handleCheckDetail,
  editWaiting,
  items,
  params,
  courts,
  workTime,
  waitingList
}: Props) {
  return (
    Array
      .from({
        length:
          (params.pageNumber * params.pageSize > params.itemsCount
            ? params.itemsCount - (params.pageNumber - 1) * params.pageSize
            : params.pageSize
          )
      })
      .map((_, i) => {
        const columnIndex = (params.pageNumber - 1) * params.pageSize + i;
        const selectedCourt = courts.find((court) => court.name === items[1].columns[columnIndex][0].courtName) as CourtInfo;
        return ({
          title: ColumnTittle({ selectedCourt }),
          dataIndex: ['columns', columnIndex],
          width: 100,
          render: (columns: Column[], booking: CourtBooking, index: number) => {
            const sortedColumns = [...columns].sort((a, b) => (a.bookingId ?? 0) - (b.bookingId ?? 0));
            const mainColumn = sortedColumns[0];
            const columnBookingType = bookingType[mainColumn.bookingType ?? 0];
            const isEmptyColumn = mainColumn.bookingId === null;
            const columnWaitingList = waitingList[index - 1];
            const isColumnEnabledForWaiting = mainColumn.bookingId === null && columnWaitingList?.entries.length !== 0 && columnWaitingList !== undefined;
            const userNames = sortedColumns.flatMap(({ userName }) => userName ? [userName] : []);
            const coachNames = sortedColumns.flatMap(({ coachName }) => coachName ? [coachName] : []);

            return (
              index !== 0
                ? (
                  <button
                    key={Number(`${booking.startTime.slice(-5, -3)}${booking.startTime.slice(-2)}${mainColumn.courtId}`)}
                    onClick={() => {
                      if (!isEmptyColumn) {
                        handleCheckDetail(sortedColumns.map(({ bookingId }) => bookingId) as number[]);
                      } else {
                        const bookingTime = dayjs(booking.startTime);
                        const isWorkTime =
                          (workTime.closed - bookingTime.hour() > 1) || (workTime.closed - bookingTime.hour() === 1 && bookingTime.minute() !== 30);
                        if (isWorkTime) {
                          handleBooking({
                            courtId: mainColumn.courtId,
                            startTime: booking.startTime,
                            courtName: mainColumn.courtName
                          });
                        }
                      }
                    }}
                    onContextMenu={(e) => {
                      e.preventDefault();
                      if (isColumnEnabledForWaiting) {
                        editWaiting(columnWaitingList.entries.map(({ id }) => id));
                      }
                    }}
                    style={{
                      cursor: 'pointer',
                      position: 'relative',
                      display: 'block',
                      backgroundColor: getBookingColor({ bookingType: mainColumn.bookingType, isColumnEnabledForWaiting, userHasDeposit: mainColumn.userHasDeposit }),
                      height: '32px',
                      border: 'none',
                      borderBottom: (
                        (
                          isEmptyColumn
                          || mainColumn.isBookingEnd
                        ) && !isColumnEnabledForWaiting
                      )
                        ? '1px solid #f0f0f0'
                        : 'none',
                      width: '100%',
                    }}
                  >
                    {
                      !isEmptyColumn && mainColumn.isBookingStart &&
                      columnBookingType !== 'tournament' && columnBookingType !== 'groupe' && (
                        <div
                          style={{
                            position: 'absolute',
                            right: '0%',
                            top: '0%',
                            width: 0,
                            height: 0,
                            borderLeft: '30px solid transparent',
                            borderRight: `30px solid ${mainColumn.confirmed ? 'rgba(80, 200, 120, 1)' : '#FE3324'}`,
                            borderBottom: '30px solid transparent',
                          }}
                        />
                      )
                    }
                    {
                      mainColumn.isBookingStart &&
                      (userNames.length !== 0
                        || coachNames.length !== 0
                        || mainColumn.note
                        || mainColumn.groupeName
                      ) && (
                        <BookingDescription
                          userNames={userNames}
                          coachNames={coachNames}
                          groupeName={mainColumn.groupeName}
                          note={mainColumn.note}
                          balance={
                            columnBookingType === 'groupe'
                              ? sortedColumns[1]?.userBalance
                              : mainColumn.userBalance
                          }
                        />
                      )
                    }
                  </button >
                )
                : (
                  <div style={{ height: '17px', borderBottom: '1px solid #f0f0f0' }}></div>
                )
            );
          },
          sorter: () => 0,
          sortIcon: () => null,
          showSorterTooltip: false,
          onCell: () => ({
            style: {
              padding: 0,
              borderTop: 'none',
              borderBottom: 'none',
              borderLeft: 'none',
              borderRight: '1px solid #f0f0f0',
            }
          }),
        });
      }
      )
  );
}

export default GraphColumns;
